import { createContext, Dispatch, useReducer } from 'react'

import { SearchMapReducer } from './searchMap.reducer'
import { SearchMapInitialState } from './searchMap.state'

export const SearchMapContextStore = createContext(SearchMapInitialState)
// SearchMapContextStore will trigger constant updates for anything using dispatch
// Separate a DispatchContext that will remain stable
export const DispatchContext = createContext<
  Dispatch<{
    type: string
  }>
>(() => void 0)

export function SearchMapContextProvider({
  children,
  value = SearchMapInitialState,
}: {
  children: React.ReactNode
  value?: typeof SearchMapInitialState
}): JSX.Element {
  const [state, dispatch] = useReducer(SearchMapReducer, value)

  return (
    <DispatchContext.Provider value={dispatch}>
      <SearchMapContextStore.Provider value={state}>{children}</SearchMapContextStore.Provider>
    </DispatchContext.Provider>
  )
}
